import { Injectable,ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { observable } from 'mobx-angular';
import { PostRequestBase,ScreenModel } from '../models/common';
import { generateProductDescription } from '../utilities/generateProductDescription';
import { ApiService } from './api-mock.service';
import { GlobalsService } from './globals.service';

@Injectable({
  providedIn: 'root',
})
export class AppUtilityService {
  @observable isLoggedIn = false;

  constructor(
    private globals: GlobalsService,
    private apiService: ApiService,
    private router: Router,
   // private el: ElementRef,
    private modalService: NgbModal,
  ) {}

  async initializeAfterLogin() {
    this.setIsLoggedIn(true);

    const globalData = await this.apiService.getGlobalData({});

    const recommendedProducts = globalData.RecommendedProducts;
    const recommendedProductsDetailDescription = {
      lowRiskDescription: generateProductDescription(
        recommendedProducts,
        'low',
      ),
      moderateRiskDescription: generateProductDescription(
        recommendedProducts,
        'moderate',
      ),
      highRiskDescription: generateProductDescription(
        recommendedProducts,
        'high',
      ),
    };

    const nonRecommendedProducts = globalData.NonRecommendedProducts;
    const nonRecommendedProductsDetailDescription = {
      lowRiskDescription: generateProductDescription(
        nonRecommendedProducts,
        'low',
      ),
      moderateRiskDescription: generateProductDescription(
        nonRecommendedProducts,
        'moderate',
      ),
      highRiskDescription: generateProductDescription(
        nonRecommendedProducts,
        'high',
      ),
    };

    this.globals.updateModel({
      ...globalData,
      recommendedProductsDetailDescription,
      nonRecommendedProductsDetailDescription,
    });
  }

  setIsLoggedIn(isLoggedIn: boolean) {
    this.isLoggedIn = isLoggedIn;
  }

  async logout(data: PostRequestBase | any) {

    //const model = new ScreenModel(this.globals, this.apiService, this.el);
    
   
    this.setIsLoggedIn(false);
    //this.modalService.dismissAll('logout');
    await this.router.navigateByUrl('/login');
  }
}
